import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { finalize, takeUntil } from 'rxjs/operators';
import { TieService } from '../../_core/services/tie.service';
import { ToastService } from '../../_core/services/toast.service';
import { SelectTeamComponent } from '../../my-teams/select-team/select-team.component';
import { Team } from '../../_shared/models/team.model';
import { DatetimeComponent } from '../../_shared/components/datetime/datetime.component';
import { roundToNearestMinutes } from 'date-fns';
import { format, utcToZonedTime } from 'date-fns-tz';
import { DisciplineEnum } from '../../_shared/models/csTypes/enums/discipline';
import { PolicyService } from '../../_core/services/policy.service';
import { Subject } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
@Component({
  standalone: false,
    selector: 'app-create-tie',
    templateUrl: './create-tie.component.html',
    styleUrls: ['./create-tie.component.scss'],
})
export class CreateTieComponent implements OnInit, OnDestroy {
    @Input() leagueId: string;
    @Input() teams: Team[];
    @Input({required: false}) isHidePolicy: boolean = false;
    policyService = inject(PolicyService);
    private readonly destroy$: Subject<void> = new Subject();
    public authService = inject(AuthService);

    form: UntypedFormGroup;
    isLoading = false;
    team1Name: string;
    team2Name: string;
    policyList: any[] = [];
    selectedPolicy: any;

    constructor(
        private modalController: ModalController,
        private fb: UntypedFormBuilder,
        private tieService: TieService,
        private toast: ToastService
    ) { }

    ngOnInit() {
        this.buildForm();
        if(!this.isHidePolicy){
            this.getAllLplicies();
        }        
    }

    buildForm() {
        const formConfig: any = ({
            discipline: [DisciplineEnum.TENNIS, Validators.required],
            startDate: [this.getTimeToDisplay(), Validators.required],
            team1Id: [''],
            team2Id: [''],
            template: [''],
            applyLineup: [false],
            note: ['', [Validators.minLength(1)]],
        });
        if(!this.isHidePolicy){
            formConfig.policy = [null];
        }
        this.form = this.fb.group(formConfig);
    }

    async selectTeam(teamNumber) {
        const modal = await this.modalController.create({
            component: SelectTeamComponent,
            componentProps: {
                teams: this.teams,
                leagueId: this.leagueId
            },
            presentingElement: await this.modalController.getTop()
        });

        await modal.present();

        const { data } = await modal.onDidDismiss();
        if (data) {
            if (teamNumber === 1) {
                this.form.get('team1Id').setValue(data._id);
                this.team1Name = data.name;
            } else if (teamNumber === 2) {
                this.form.get('team2Id').setValue(data._id);
                this.team2Name = data.name;
            }
        }
    }

    submit() {
        if (this.form.invalid) {
            this.toast.presentDangerToast('Both teams must be added');
            return;
        }

        this.isLoading = true;
        const tieObj = this.form.value;
        
        this.tieService
            .create(tieObj, this.leagueId)
            .pipe(finalize(
                () => this.isLoading = false
            ))
            .subscribe({
                next: res => {
                    this.toast.presentToast(res.message);
                    this.modalController.dismiss(res.data);
                }
            });
    }

    close() {
        this.modalController.dismiss();
    }

    addTemplate(template) {
        this.form.get('template').setValue(template.subtype);
    }

    private getTimeToDisplay() {
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const date = roundToNearestMinutes(new Date(), { nearestTo: 30 })
        const zonedTime = utcToZonedTime(date, userTimeZone);
        return format(zonedTime, "yyyy-MM-dd'T'HH:mmXXX", { timeZone: userTimeZone });
    }

    getAllLplicies() {
        this.policyService
          .getAllPolicies()
          .pipe(takeUntil(this.destroy$))
          .subscribe((res) => {
             this.policyList = res;
        });
    }

    onPolicySelected(event: any) {
        const selectedPolicyId = event.detail.value;
        this.selectedPolicy = this.policyList.find(p => p._id === selectedPolicyId);
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
